module.exports = __webpack_public_path__ + "assets/img/img217.0142770e.png";